module.exports = new __parcel__URL__("instagram.66ad4105.svg").toString();